/* Stickerheads OS 2.0: Mystery Sticker add can wake legacy cart-app scroll locks. Strip only foreign locks; native drawer keeps its own sh-cart-lock while open. */
(()=>{
  'use strict';
  const roots=[document.documentElement,document.body];
  const cleanForeignLocks=()=>{
    roots.forEach(el=>{
      if(!el)return;
      [...el.classList].forEach(c=>{
        if(c==='sh-cart-lock')return;
        if(/qikify|side.?cart|slide.?cart|cart.?open|drawer.?open|modal.?open|no.?scroll|scroll.?lock|overflow.?hidden/i.test(c)) el.classList.remove(c);
      });
      ['overflow','overflow-y','position','top','left','right','width','height','touch-action'].forEach(p=>el.style.removeProperty(p));
    });
    document.querySelectorAll('#qikify-cart-app,#qikify-sidecart,#qikify-slide-cart,#qikify-stickycart-v2-app,.qikify-sidecart,.qikify-slide-cart,.qikify-stickycart,[id*="qikify"][id*="cart"],[class*="qikify"][class*="cart"],iframe[src*="qikify"][src*="cart"]').forEach(el=>el.remove());
  };
  document.addEventListener('click',e=>{
    if(!e.target.closest('[data-sh-upsell-add]'))return;
    [0,50,150,300,600,1000,1600].forEach(ms=>setTimeout(cleanForeignLocks,ms));
  },true);
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-sh-cart-close]')) [0,50,200,500].forEach(ms=>setTimeout(cleanForeignLocks,ms));
  },true);
})();

/* Cart side tab: press/hold then drag freely up/down. Position is saved on this device. */
(()=>{
  'use strict';
  const init=()=>{
    const tab=document.querySelector('.sh-cart-side-tab');
    if(!tab)return;
    const key='sh-cart-tab-top-v1';
    const clamp=n=>Math.max(24,Math.min(window.innerHeight-tab.getBoundingClientRect().height-24,n));
    const apply=n=>{
      const y=clamp(n);
      tab.style.setProperty('position','fixed','important');
      tab.style.setProperty('top',y+'px','important');
      tab.style.setProperty('bottom','auto','important');
      tab.style.setProperty('transform','none','important');
    };
    const saved=parseFloat(localStorage.getItem(key));
    apply(Number.isFinite(saved)?saved:Math.round(window.innerHeight*.70));
    let timer=null,dragging=false,startY=0,startTop=0,suppressClick=false;
    const stopTimer=()=>{if(timer){clearTimeout(timer);timer=null}};
    tab.addEventListener('pointerdown',e=>{
      if(e.pointerType==='mouse'&&e.button!==0)return;
      stopTimer();startY=e.clientY;startTop=tab.getBoundingClientRect().top;suppressClick=false;
      timer=setTimeout(()=>{
        dragging=true;suppressClick=true;
        tab.setPointerCapture?.(e.pointerId);
        tab.style.setProperty('touch-action','none','important');
      },400);
    },true);
    tab.addEventListener('pointermove',e=>{
      if(!dragging)return;
      e.preventDefault();e.stopImmediatePropagation();
      apply(startTop+(e.clientY-startY));
    },true);
    const finish=e=>{
      stopTimer();
      if(!dragging)return;
      dragging=false;
      tab.style.removeProperty('touch-action');
      localStorage.setItem(key,String(Math.round(tab.getBoundingClientRect().top)));
      e.preventDefault();e.stopImmediatePropagation();
      setTimeout(()=>{suppressClick=false},250);
    };
    tab.addEventListener('pointerup',finish,true);
    tab.addEventListener('pointercancel',finish,true);
    tab.addEventListener('click',e=>{if(suppressClick){e.preventDefault();e.stopImmediatePropagation()}},true);
    window.addEventListener('resize',()=>apply(tab.getBoundingClientRect().top));
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();